import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchSuppliers = async (query) => {
  const { data } = await apiClient.get(`/suppliers`, { params: query.queryKey[1] });
  return data;
};

export const useGetSuppliersHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [suppliers, setSuppliers] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const queryClient = useQueryClient();

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery(
    {
      queryKey: ['suppliers', { ...searchQuery }], // A unique key for this query
      cacheTime: 0,
      queryFn: fetchSuppliers,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: 'always',
    },
    queryClient,
  );

  useEffect(() => {
    if (fetchedData) {
      setSuppliers(fetchedData.content);
      setTotalDocuments(fetchedData.total_elements);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    suppliers,
    totalDocuments,
    isLoading,
  };
};
